import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearStatus } from "./fileTransferSlice";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function SharedComponent() {
  const dispatch = useDispatch();
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const { isSuccess, isSuccess_Info, isFailed, isFailed_Info, isError } =
    fileTransfer;

  const handleCloseSnackbar = () => {
    dispatch(clearStatus());
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isSuccess}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {isSuccess_Info}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isFailed}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="warning"
          sx={{ width: "100%" }}
        >
          {isFailed_Info}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isError}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        ></Alert>
      </Snackbar>
    </div>
  );
}

export default SharedComponent;
